import { render, staticRenderFns } from "./dialog-handle.vue?vue&type=template&id=68281ec3&scoped=true&"
import script from "./dialog-handle.vue?vue&type=script&lang=js&"
export * from "./dialog-handle.vue?vue&type=script&lang=js&"
import style0 from "./dialog-handle.vue?vue&type=style&index=0&id=68281ec3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68281ec3",
  null
  
)

export default component.exports